import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../../shared/components/fa-icon/fa-icon.component';

@Component({
    selector: 'je-unsupported-browser',
    standalone: true,
    templateUrl: './unsupported-browser.component.html',
    imports: [TranslateModule, IconComponent],
})
export class UnsupportedBrowserComponent {}
